const options = {
  dataZoom: [
    {
      type: 'inside',
      startValue: 0,
      endValue: 6,
      zoomLock: true,
      preventDefaultMouseMove: false //禁止canvas上下滑动
    }
  ],
  grid: {
    top: '20%',
    bottom: '20%',
    left: '5%',
    right: '5%'
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    /* x轴线相关设置 */
    axisLine: {
      show: false,
      lineStyle: {
        color: '#F1F1F1'
      }
    },
    /*  */
    splitLine: {
      show: true,
      lineStyle: {
        color: 'rgba(241, 241, 241, 0.12)'
      }
    },
    //x轴刻度尺相关设置
    axisTick: {
      show: false
    },
    //坐标轴刻度标签的相关设置
    axisLabel: {
      show: true,
      margin: 10,
      color: function (value, index) {
        return value == '今日' || value == '当月'
          ? 'rgb(255,255,255)'
          : 'rgba(255,255,255,0.5)'
      }, //更改坐标轴文字颜色
      fontSize: 10
    },
    data: []
  },
  yAxis: {
    show: false,
    type: 'value',
    splitLine: {
      show: false,
      lineStyle: {
        /* type: "dashed", */
      }
    },
    min: function (value) {
      return value.min - ((value.max - value.min) / 0.5) * 0.1
    },
    max: function (value) {
      return value.max + ((value.max - value.min) / 0.5) * 0.2
    }
  },
  series: [
    {
      data: [],
      type: 'line',
      //smooth: true,
      symbol: 'circle', //折线点设置为实心点
      symbolSize: 8, //折线点的大小
      lineStyle: {
        color: 'rgb(255, 255, 255)', //曲线的颜色
        width: 2
      },
      itemStyle: {
        color: 'rgb(255, 255, 255)', //点的颜色
        borderColor: 'rgb(255, 255, 255)'
      },
      label: {
        show: true,
        position: 'top',
        fontSize: 12,
        fontWeight: 'bold',
        fontFamily: 'DIN-Bold',
        distance: 5, //数值距离折线的距离
        color: 'rgba(255,255,255,0.5)' //数值的颜色
      },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: 'transparent' // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'transparent' // 区域100% 处的颜色
            }
          ],
          global: false // 缺省为 false
        }
      }
    }
  ]
}
const weightOptions = {
  dataZoom: [
    {
      type: 'inside',
      startValue: 0,
      endValue: 6,
      zoomLock: true,
      preventDefaultMouseMove: false //禁止canvas上下滑动
    }
  ],
  grid: {
    top: '30%',
    bottom: '20%',
    left: '10%',
    right: '10%'
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    /* x轴线相关设置 */
    axisLine: {
      show: true,
      lineStyle: {
        color: '#F1F1F1'
      }
    },
    /*  */
    splitLine: {
      show: true,
      lineStyle: {
        color: '#F1F1F1'
      }
    },
    //x轴刻度尺相关设置
    axisTick: {
      show: false
    },
    //坐标轴刻度标签的相关设置
    axisLabel: {
      show: true,
      margin: 10,
      color: function (value, index) {
        return value == '今日' ? 'rgb(0,0,0)' : 'rgba(0,0,0,0.5)'
      }, //更改坐标轴文字颜色
      fontSize: 10
    },
    data: []
  },
  yAxis: {
    show: false,
    type: 'value',
    splitLine: {
      show: false,
      lineStyle: {
        /* type: "dashed", */
      }
    },
    min: function (value) {
      return value.min - ((value.max - value.min) / 0.5) * 0.1
    },
    max: function (value) {
      return value.max + ((value.max - value.min) / 0.5) * 0.2
    }
  },
  series: [
    {
      data: [],
      type: 'line',
      //smooth: true,
      symbol: 'circle', //折线点设置为实心点
      symbolSize: 8, //折线点的大小
      lineStyle: {
        color: 'rgb(98, 54, 255)', //曲线的颜色
        width: 2
      },
      itemStyle: {
        color: 'rgb(98, 54, 255)', //点的颜色
        borderColor: 'rgb(98, 54, 255)'
      },
      label: {
        show: true,
        position: 'top',
        fontSize: 12,
        distance: 5, //数值距离折线的距离
        color: '#6236FF', //数值的颜色
        fontWeight: 'bold',
        fontFamily: 'DIN-Bold'
      },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: 'transparent' // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'transparent' // 区域100% 处的颜色
            }
          ],
          global: false // 缺省为 false
        }
      }
    }
  ]
}
export { options, weightOptions }
